import clsx from 'clsx';
import { memo } from 'react';

import type { NomineeEntity } from '../../types';

import * as style from './style.module.scss';

const EntityName = ({ entity, className }: { entity: NomineeEntity; className?: string }) => {
  return <p className={clsx(style.nomineeName, className)}> {entity?.shortName || entity?.internationalName}</p>;
};

export default memo(EntityName);
